import RadioButtonListItem from "@components/radio-button-list-item";
import { View } from "dripsy";
import * as React from "react";
import Error from "@features/error/error";

interface RadioButtonGroupT<V extends number | string> {
  values: {
    id: V;
    label: string;
    icon?: { uri: string };
  }[];
  value: V;
  onChange: (value: V) => void;
  onLayout: any;
  disabledIndexes?: number[];
  error?: boolean;
  errorMessage?: string;
}

function RadioButtonGroup<V extends number | string>({
  values,
  value,
  onChange,
  onLayout,
  disabledIndexes,
  error,
  errorMessage,
}: RadioButtonGroupT<V>) {
  return (
    <View onLayout={onLayout}>
      {values.map((item, index) => (
        <RadioButtonListItem
          key={item.id}
          value={item.id === value}
          onChange={() => onChange(item.id)}
          title={item.label}
          icon={item.icon}
          disabled={disabledIndexes?.includes(index)}
        />
      ))}
      {error ? <Error error={errorMessage} isError={!!error} paddingBottom="$2" /> : null}
    </View>
  );
}
export default RadioButtonGroup as typeof RadioButtonGroup;
